import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'

import ContentHeader from 'component/utils/ContentHeader'
import * as gamaActions from 'action/gama'
import * as supplyActions from 'action/paramsSupply'
import Form from 'component/paramsSupply/EditForm'

import SuccessModal from 'component/Modal/SuccessModal'
import ErrorModal from 'component/Modal/ErrorModal'

class ParamsSupply extends Component {
  state = {
    showSuccess: false,
    showError: false,
  }

  handleSubmit = (args, callback) => {
    const {
      updateSupplyParams,
      auth: { user }
    } = this.props
    args.cdLdap = user.username
    args.dsLdap = user.fullName
    updateSupplyParams(user.dsToken, args).then((res) => {
      if (res.cdStatus === 200) {
        this.setState({ showSuccess: true }, callback())
      }
      if( res.cdStatus === 400) {
        this.setState({showError: true})
      }
    })
  }

  render() {
    const { translate, auth,savedSupplyParam,  error, fetchSections } = this.props
    const { showSuccess, showError } = this.state

    return (
      <div className='irc'>
        <ContentHeader>{translate('params.supply')}</ContentHeader>

        {showError && (
          <ErrorModal
            handleClose={() => this.setState({ showError: false })}
            msg={translate('Erro ao salvar os parâmetros do IRC - Supply')}
            size='sm'
            t={translate}
            center
            buttonText='OK'
            fillButton
          />
        )}
        {showSuccess && (
          <SuccessModal
            handleClose={() => this.setState({ showSuccess: false })}
            msg={translate('params.supply.success')}
            size='sm'
            t={translate}
            center
            buttonText='OK'
            fillButton
          />
        )}

        <Form
          translate={translate}
          onSubmit={this.handleSubmit}
          auth={auth}
          error={error}
          savedSupplyParam={savedSupplyParam}
          fetchSections={fetchSections}
        />
      </div>
    )
  }
}

ParamsSupply.propTypes = {
  auth: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  error: PropTypes.object,
  updateGama: PropTypes.func.isRequired,
  fetchSections: PropTypes.func.isRequired,
  savedSupplyParam: PropTypes.object,
  updateSupplyParams: PropTypes.func.isRequired,
}

const mapStateToProps = /* istanbul ignore next */ ({ paramsSupplyReducer }) => ({
  savedSupplyParam: paramsSupplyReducer.get.record,
  error: paramsSupplyReducer.save.error,
})

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({...gamaActions,...supplyActions}, dispatch)

/* istanbul ignore next */
const ParamsSupplyTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(ParamsSupply)

/* istanbul ignore next */
export default connect(mapStateToProps, mapDispatchToProps)(ParamsSupplyTranslated)

export { ParamsSupply }
